import React from 'react';
import strings from "../../../localization";
import { bindActionCreators } from "redux";
import { withSnackbar } from "notistack";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import * as Actions from "../../../actions/Actions";
import Page from '../../../common/Page';
import SelectControl from '../../../components/controls/SelectControl';
import IconButton from "@material-ui/core/IconButton";
import { getCardGraveSiteAll, getDeceased, getLease } from '../../../services/reviews/reviewsRecords/CardGraveSiteService';
import { getAllGraveyards, getGraveyardById } from '../../../services/graveyard/GraveyardService';
import { getGraveNotTakenSites, getGraveSiteById, getGraveSites, getGraveSitesWithSelectedGraveyard } from '../../../services/graveSite/GraveSiteService';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core';
import CardGraveSiteList from './CardGraveSiteList';
import CardGraveSiteHeader from './CardGraveSiteHeader';
import { getMainBookOfBuriedById } from '../../../services/mainBookOfBuried/MainBookOfBuriedService';
import { getFamousCitizenById } from '../../../services/famousCitizen/FamousCitizenService';
import update from 'immutability-helper';
import { getCremationStatementsByGraveSiteId } from '../../../services/cremationStatement/CremationStatementService';


class CardGraveSiteInputForm extends Page {

  constructor(props) {
    super(props);


    this.state = {
      ...this.state,
      data: {
        graveyard: { value: "none" },
      },
      graveSite: {},
      graveyards: [],
      graveSites: [],
      responseData: [],
      deceasedFamousCitizenId: -1,
      deceasedFamousCitizenCode: -1,
      contractExpiryDate: null
    }

    this.keyPress = this.keyPress.bind(this);
  }

  getGraveyards() {
    getAllGraveyards().then(response => {
      let graveyardCodes = [];
      for (let obj of response.data.entities) {
        graveyardCodes.push({
          name: obj.code + " - " + obj.name,
          value: obj.name,
          code: obj.code,
          id: obj.id
        });
      }

      this.setState({ graveyards: graveyardCodes });
    });
  }

  componentDidMount() {
    this.setState({
      companyId: this.props.auth.user.company.id,
    }, () => {
      this.getGraveyards();

      // When opened from another list's row menu, a grave site id is passed via router state.
      const incoming = this.props.location != null ? this.props.location.state : null;
      if (incoming != null && incoming.graveSiteId != null) {
        this.openCardForGraveSite(incoming.graveSiteId);
      }
    });
  }

  openCardForGraveSite(graveSiteId) {
    const userId = this.props.auth.user.id;
    const companyId = this.props.auth.user.company.id;

    getGraveSiteById(graveSiteId, userId, companyId).then(response => {
      if (!response.ok) {
        return;
      }

      const graveSite = response.data;

      getGraveyardById(graveSite.belongingGraveyardId, userId, companyId).then(graveyardResponse => {
        if (!graveyardResponse.ok) {
          return;
        }

        const graveyard = graveyardResponse.data;

        this.setState({
          data: {
            ...this.state.data,
            graveyard: {
              name: graveyard.code + " - " + graveyard.name,
              value: graveyard.name,
              code: graveyard.code,
              id: graveyard.id
            },
            graveSite: graveSite
          }
        }, () => {
          this.sendGraveyardIdAndGraveSiteId({
            graveyardCode: graveyard.code,
            graveSiteId: graveSite.id,
            companyId: companyId,
            userId: userId,
            page: 0,
            size: 100
          });
        });
      });
    });
  }

  keyPress(e) {
    if (e.key == "Enter") {
      e.preventDefault();
      let data = {
        graveyardCode: this.state.data.graveyard != null ? this.state.data.graveyard.code : "",
        graveSiteId: this.state.data.graveSite != null ? this.state.data.graveSite.id : "",
        companyId: this.state.companyId,
        userId: this.props.auth.user.id,
        page: 0,
        size: 100,
      };
      this.sendGraveyardIdAndGraveSiteId(data);
    }
  }

  keyPressBackspace(e) {
    if (e.target.value.length == 2 && e.keyCode !== 8) {
      e.target.value = e.target.value + '/';
    }

    if (e.target.value.length == 5 && e.keyCode !== 8) {
      e.target.value = e.target.value + '-';
    }

    if (e.keyCode !== 8) {
      return;
    }

    if (e.target.value.charAt(e.target.value.length - 2) == "-" || e.target.value.charAt(e.target.value.length - 2) == "/") {
      e.target.value = e.target.value.substring(0, e.target.value.length - 1);
    }
    else {
      e.target.value = e.target.value.substring(0, e.target.value.length);
    }
  }
  componentWillReceiveProps(nextProps) {
    strings.setLanguage(nextProps.auth.user.language);
    {
      this.state.showTable &&
        getGraveSiteById(this.state.data.graveSite.id, this.props.auth.user.id, this.props.auth.user.company.id).then(response => {
          if (!response.ok) {
            return
          }

          this.setState({
            graveSite: response.data
          });
        });
    }
  }

  /** 
   * Handles autocomplete type input change event
   * When user typed in characters it searches for results to fill dropdown 
   */
  handleTextInputChange = (e) => {
    if (e.target.name === "graveSite") {
      let data = {
        searchParam: e.target.value,
        companyId: this.state.companyId,
        sort: "code,ASC",
        renewal: -1,
        graveyardId: this.state.data.graveyard.id,
        type: "-1",
        userId: 0
      };

      {
        this.state.companyId != undefined &&
          getGraveSitesWithSelectedGraveyard(data).then(response => {
            if (!response.ok) {
              return;
            }
            this.setState({
              graveSites: response.data.entities,
            });
          });
      }
    }
  }

  onAutocompleteChange = (event, values) => {
    let autocompleteName = event.target.id.split("-")[0];
    this.setState({
      data: {
        ...this.state.data, [autocompleteName]: values
      }
    });
  }

  renderText() {
    return (
      <div className='card-grave-site-header'>
        <h1> {strings.review.reviewsRecords.cardGraveSite}</h1>
      </div>
    );
  }

  changeData(event, data = 'data') {
    this.setState({
      [data]: update(this.state[data], { [event.target.name]: { $set: event.target.value } })
    }, () => {
      if (event.target.name == 'graveyard') {
        this.setState({
          graveSites: [],
          data: {
            ...this.state.data,
            graveSite: null,
          }
        });
      }
    });

  }

  changeExpiryDateDisplay = (date) => {
    this.setState({
      contractExpiryDate: date
    });
  }

  renderFilter() {
    return (
      <div className='card-grave-site-select'>
        <SelectControl
          options={this.state.graveyards}
          selected={this.state.data.graveyard}
          onChange={this.changeData}
          label={strings.review.tables.funerals.selectedGraveyard}
          name={"graveyard"}
          nameKey={"name"}
          valueKey={"value"}
          codeKey={"code"}
          placeholder={strings.cardGraveSiteList.select}
        />

        { (this.state.data.graveyard != undefined && this.state.data.graveyard != null && this.state.data.graveyard.value != "none") &&
          <Autocomplete
            id={"graveSite"}
            name={"graveSite"}
            options={this.state.graveSites}
            getOptionLabel={option => option.code}
            onChange={this.onAutocompleteChange}
            renderInput={params => (
              <TextField
                {...params}
                variant="standard"
                label={strings.mainBookOfBuried.form.graveSite}
                margin="normal"
                fullWidth
                name={"graveSite"}
                onChange={this.handleTextInputChange}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
            disableClearable={true}
            disabled={false}
            value={this.state.data.graveSite}
            onKeyDown={this.keyPressBackspace}
            onKeyPress={this.keyPress}
          />
        }

        {(this.state.data.graveyard == undefined || this.state.data.graveyard == null || this.state.data.graveyard.value == "none") &&
          <Autocomplete
            id={"graveSite"}
            name={"graveSite"}
            options={this.state.graveSites}
            getOptionLabel={option => option.code}
            onChange={this.onAutocompleteChange}
            renderInput={params => (
              <TextField
                {...params}
                variant="standard"
                label={strings.mainBookOfBuried.form.graveSite}
                margin="normal"
                fullWidth
                name={"graveSite"}
                onChange={this.handleTextInputChange}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
            disableClearable={true}
            disabled={true}
            value={null}

          />
        }

      </div>
    );
  }

  renderButton() {
    let data = {
      graveyardCode: this.state.data.graveyard != null ? this.state.data.graveyard.code : "",
      graveSiteId: this.state.data.graveSite != null ? this.state.data.graveSite.id : "",
      companyId: this.state.companyId,
      userId: this.props.auth.user.id,
      page: 0,
      size: 100,
    };

    return (
      <div className="select-grave-site-button">
        <IconButton onClick={() => this.sendGraveyardIdAndGraveSiteId(data)} disabled={this.state.data.graveyard.value == 'none'}>
          {strings.review.buttons.find}
        </IconButton>
      </div>

    );
  }

  // Обавештење "носилац уговора преминуо" се изводи само из активног уговора: најновијег
  // несторнираног уговора, оног чији се датум истека приказује у заглављу картона. Старији
  // несторнирани записи (нпр. пратећи "REZ DUB" уз сторнирану резервацију) се не гледају.
  findDeceasedHolder(validItems, latestDate) {
    return validItems
      .filter(item => item.contractExpiryDate === latestDate)
      .find(item => item.holderDeceased === true) || null;
  }

  sendGraveyardIdAndGraveSiteId(data) {
    getCremationStatementsByGraveSiteId(data.graveSiteId, data.companyId).then(response => {
      if (!response.ok) {
        return;
      }
      console.log(response.data);
      //if response.data.entities.length > 0 then set state which is hasCremationStatement true
      this.setState({
        hasCremationStatement: response.data.entities.length > 0
      });
    });

    getLease(data).then(response => {
      let latestDate = null;
      let deceasedHolder = null;
      if (response.data.content.length > 0) {
        const validItems = response.data.content.filter(item =>
          !item.indicator || !item.indicator.includes("STORNO")
        );

        if (validItems.length > 0) {
          latestDate = validItems[0].contractExpiryDate;
          for (let i = 1; i < validItems.length; i++) {
            if (validItems[i].contractExpiryDate > latestDate) {
              latestDate = validItems[i].contractExpiryDate;
            }
          }
          deceasedHolder = this.findDeceasedHolder(validItems, latestDate);
        }
      }
      this.setState({
        contractExpiryDate: latestDate,
        contractHolderDeceased: deceasedHolder != null,
        deceasedContractGks: deceasedHolder != null ? deceasedHolder.holderMainBookOfBuries : null
      });
    });
    
    getDeceased(data).then(response => {
      if (!response.ok) {

        return;
      }

      this.setState({
        showTable: true,
        responseData: response.data.content,
      }, () => {
        let i;
        let id = -1;
        for (i = 0; i < response.data.content.length; i++) {
          if (response.data.content[i].indicator === "pok") {
            id = response.data.content[i].id;
            break;
          }
        }
        {
          id != -1 &&
            getMainBookOfBuriedById(id, this.props.auth.user.id, this.props.auth.user.company.id).then(response => {
              this.setState({
                mainBookOfBuriedId: id,
                deceasedFamousCitizenId: response.data.famousCitizenId ? response.data.famousCitizenId : -1
              }, () => {
                {
                  this.state.deceasedFamousCitizenId != -1 &&
                    getFamousCitizenById(this.state.deceasedFamousCitizenId, this.props.auth.user.id, this.props.auth.user.company.id).then(response => {
                      if (!response.ok) {
                        return;
                      }
                      this.setState({
                        deceasedFamousCitizenCode: response.data.code
                      });
                    });
                }
             
              });
            });
        }
        this.setState({
          deceasedFamousCitizenCode: ""
        })
      })
    });
  }

  hideTableShowSearch() {
    this.setState({
      showTable: false
    })
  }

  render() {
    return (
      <div>
        {!this.state.showTable &&
          this.renderText()
        }
        {!this.state.showTable &&
          this.renderFilter()
        }
        {!this.state.showTable &&
          this.renderButton()
        }
        {this.state.showTable &&
          <div>
            <CardGraveSiteHeader
              graveyardName={this.state.data.graveyard.name}
              graveSiteCode={this.state.data.graveSite.code}
              graveSiteSize={this.state.data.graveSite.size}
              contractExpiryDate={this.state.contractExpiryDate}
              validContract={this.state.data.graveSite.validContract}
              expirationDate={this.state.data.graveSite.expirationDate}
              hasCremationStatement={this.state.hasCremationStatement}
              note={this.state.data.graveSite.note}
              contractHolderDeceased={this.state.contractHolderDeceased}
              deceasedContractGks={this.state.deceasedContractGks}
              funeralAtDepth={this.state.data.graveSite.funeralAtDepth}
            />
            <CardGraveSiteList changeExpiryDateDisplay={this.changeExpiryDateDisplay} data={this.state.responseData} graveyardCode={this.state.data.graveyard.code} graveSiteId={this.state.data.graveSite.id}/>
            <IconButton onClick={() => this.hideTableShowSearch()}>
              {strings.review.buttons.back}
            </IconButton>
          </div>
        }

      </div>
    );
  }

}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    changeFullScreen: Actions.changeFullScreen
  }, dispatch);
}

function mapStateToProps({ menuReducers, authReducers, siteDataReducers }) {
  return { menu: menuReducers, auth: authReducers, siteData: siteDataReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(CardGraveSiteInputForm)));
